import React, { useEffect, useState } from "react";
import wokeloLogo from "../assests/wokeloLogo.svg";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { login } from "../store/slice/authSlice";
import Input from "../components/input";
import { FaSpinner } from "react-icons/fa";
import { loginRequest } from '../authConfig';
import { useMsal } from '@azure/msal-react';
import { EventType,InteractionType } from '@azure/msal-browser';

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [env, setEnv] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  
  const { instance } = useMsal()
  const handleLoginRedirect = async() => {
      instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };

  const handleUserDetails=async(user)=>{
    const tokenDetails = await instance.acquireTokenSilent({
				scopes: loginRequest.scopes,
				account: user
		})
    
    const config = {
      source: {
        endpoint: process.env.REACT_APP_SOURCE_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_SOURCE_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_SOURCE_APP_CLIENT_SECRET,
      },
      test: {
        endpoint: process.env.REACT_APP_TEST_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_TEST_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_TEST_APP_CLIENT_SECRET,
      },
      prod: {
        endpoint: process.env.REACT_APP_PROD_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_PROD_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_PROD_APP_CLIENT_SECRET,
      },
    };

    const endpoint = config?.[env]?.endpoint
    const client_id = config?.[env]?.client_id 
    const client_secret  = config?.[env]?.client_secret

    if( endpoint && client_id && client_secret ){
      const tokenInfo = {
        grant_type: 'convert_token',
        client_id: client_id,
        client_secret: client_secret,
        backend: 'azuread-oauth2',
        token: tokenDetails?.accessToken,
        username: tokenDetails.account?.username,
        id_token: tokenDetails?.idToken,
        is_sandbox_request: "1"
    }
    
    setIsLoading(true);
    axios
      .post(`${endpoint}/convert-token/`, tokenInfo)
      .then(async(res) => {
        const response = await axios(
          `${endpoint}/accounts/user_detail/`,
          {
            method: "GET",
            headers: {
              'Authorization': `Bearer ${res.data.access_token}`
            },
          }
        );
        if((response.data.staff)){
          toast.success("Login Successful");
          setIsLoading(false);
          // ,expire_date:getDate(action.payload.expires_in)
          dispatch(login({ username: tokenDetails.account?.username, ...res.data, env: env }));
        }else{
          toast.error("You are not authorized");
          setIsLoading(false);
        }  
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.error("Login Failed");
      });
    }

  }
  useEffect(() => {
        if (instance) {
            const _ = instance.addEventCallback((event) => {
                if ((event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.LOGIN_SUCCESS) && event.interactionType === InteractionType.Redirect && event.payload.account) {
                    handleUserDetails(event.payload.account)
                }
            })
        }
    }, [instance,env])

  const handleLogoutRedirect = () => {
      instance.logoutRedirect().catch((error) => console.log(error));
  };
  const onSubmit = () => {
    const config = {
      source: {
        endpoint: process.env.REACT_APP_SOURCE_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_SOURCE_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_SOURCE_APP_CLIENT_SECRET,
      },
      test: {
        endpoint: process.env.REACT_APP_TEST_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_TEST_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_TEST_APP_CLIENT_SECRET,
      },
      prod: {
        endpoint: process.env.REACT_APP_PROD_AUTH_ENDPOINT,
        client_id: process.env.REACT_APP_PROD_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_PROD_APP_CLIENT_SECRET,
      },
    };

    const { endpoint, client_id, client_secret } = config[env];
    setIsLoading(true);
    axios
      .post(`${endpoint}/token/`, {
        username: email,
        password,
        grant_type: "password",
        client_id,
        client_secret,
      })
      .then(async(res) => {
        const response = await axios(
          `${endpoint}/accounts/user_detail/`,
          {
            method: "GET",
            headers: {
              'Authorization': `Bearer ${res.data.access_token}`
            },
          }
        );
        if((response.data.staff)){
          toast.success("Login Successful");
          setIsLoading(false);
          // ,expire_date:getDate(action.payload.expires_in)
          dispatch(login({ username: email, ...res.data, env: env }));

         }else{
          toast.error("You are not authorised");
          setIsLoading(false);
        }  
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
        toast.error("Login Failed");
      });
  };
  useEffect(()=>{
    const env = localStorage.getItem("sandbox-env")
    if(env){
      setEnv(env)
    }
  },[])

  useEffect(()=>{
    if(env){
      localStorage.setItem('sandbox-env',env)
    }
  },[env])

  return (
    <div className="h-[100vh] bg-gray-100 w-full flex justify-center items-center">
      <div className="w-[500px] bg-white p-5 rounded-lg shadow-md border text-gray-800">
        <div className="flex w-full justify-center">
          <img className="w-[200px] mb-4" src={wokeloLogo} />
        </div>

        <div className="mb-4 text-xl font-semibold">Welcome to Sandbox</div>

        {/* <div>
          <div className="text-sm font-semibold mb-2 ">Email</div>
          <Input
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            type="email"
            className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your email"
          />
        </div>

        <div className="mt-2">
          <div className="text-sm font-semibold mb-2 ">Password</div>
          <Input
            value={password}
            type={"password"}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your password"
          />
        </div> */}

        <div className="mt-2">
          <div className="text-sm font-semibold mb-2 ">Environment</div>
          <select
            value={env}
            onChange={(e) => {
              setEnv(e.target.value);
            }}
            className="border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 "
            placeholder="Enter your password"
          >
            <option value={""}>Choose</option>
            <option value={"prod"}>Production</option>
            <option value={"test"}>Test</option>
            <option value={"source"}>Source</option>
          </select>
        </div>

         {/* <button
          className="bg-black text-white py-3 hover:shadow-lg disabled:bg-[#b6b6b6] font-semibold disabled:cursor-not-allowed text-center w-full rounded-lg mt-4"
          type="button"
          disabled={env === "" || email === "" || password === "" || isLoading}
          onClick={() => {
            onSubmit();
          }}
        >
          {isLoading ? (
            <div className="animate-spin flex justify-center">
              <FaSpinner />
            </div>
          ) : (
            <p className="font-semibold text-sm">Login 3i</p>
          )}
        </button>  */}

        <button
          className="bg-black mt-4 text-white py-3 hover:shadow-lg disabled:bg-[#b6b6b6] font-semibold disabled:cursor-not-allowed text-center w-full rounded-lg mt-4"
          type="button"
          disabled={env==''}
          onClick={() => {
            handleLoginRedirect();
          }}
        >
           {isLoading ? (
            <div className="animate-spin flex justify-center">
              <FaSpinner />
            </div>
          ) : (
            <p className="font-semibold text-sm">Login</p>
          )}
        </button>
      </div>
    </div>
  );
};

export default LoginPage;